var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 924,
    viewBox: "0 0 1440 924",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.211 824.422C172.225 875.372 56.5464 901.259 6.10352e-05 923.78V4.79054C491.574 1.47858 1480.92 -3.77407 1438 4.17464C1384.34 14.1105 1326.22 76.7461 1294.24 121.458C1262.27 166.169 1213.49 212.868 1138.15 234.23C1062.82 255.592 993.987 216.345 900.225 255.592C806.463 294.839 769.066 344.021 741.967 405.624C714.869 467.226 699.693 531.313 613.519 573.54C527.344 615.768 477.482 583.973 375.591 629.678C273.699 675.383 289.958 755.367 222.211 824.422Z",
    fill: "url(#paint0_linear_1318_283)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1318_283",
    x1: 711.22,
    y1: 23.1744,
    x2: 711.22,
    y2: 923.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465282"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBackground);
export default __webpack_public_path__ + "static/media/welcomeBackground.e97875e992477e5ef3c83b9c3ef09d2c.svg";
export { ForwardRef as ReactComponent };